import * as WtsAreas from './catalogs/areas';
import * as WtsCoursesAreas from './catalogs/coursesAreas';
import * as WtsCoursesStatus from './catalogs/coursesStatus';
import * as WtsPositions from './catalogs/positions';
import * as WtsProfiles from './catalogs/profiles';
import * as WtsSkills from './catalogs/skills';
import * as WtsDealer from './catalogs/dealer';
import * as WtsAgencies from './catalogs/agencies';
import * as WtsEmployees from './catalogs/employees';
import * as WtsCourses from './courses/courses';
import * as WtsCoursAgenda from './catalogs/courseAgenda';
import * as WtsCourseAgendaDealer from './catalogs/courseAgendaDealer';
import * as WtsAuth from './catalogs/wtsAuth';
import * as WtsEmailNotify from './catalogs/wtsEmailNotify';
import * as WtsParams from './catalogs/paramsWts';
import * as WtsCourseDocument from './catalogs/courseDocument';
import * as WtsEmployeesCert from './employee/employeeCerts';
import * as WtsEmployeeMatricula from './employee/employeeMatricula';
import * as WtsRegistroAgencias from './registroAgencias/registroAgencias';
import * as WtsEmployeeNotify from './employee/employeeNotify';

const Actions = {
  ...WtsAreas,
  ...WtsCoursesAreas,
  ...WtsCoursesStatus,
  ...WtsPositions,
  ...WtsProfiles,
  ...WtsSkills,
  ...WtsDealer,
  ...WtsAgencies,
  ...WtsEmployees,
  ...WtsCourses,
  ...WtsCoursAgenda,
  ...WtsCourseAgendaDealer,
  ...WtsAuth,
  ...WtsEmailNotify,
  ...WtsParams,
  ...WtsCourseDocument,
  ...WtsEmployeesCert,
  ...WtsEmployeeMatricula,
  ...WtsRegistroAgencias,
  ...WtsEmployeeNotify,
};

export default Actions;
